import type { ModuleWeb } from '../registry.js';

import { NotesRoute } from './NotesPage.js';

export const exampleWeb: ModuleWeb = {
  module: 'example',
  routes: [{ path: '/example', element: <NotesRoute /> }],
};
